import React, { useCallback, useMemo } from "react";
import { Button, Icon, SubmitButton} from "../components/controls";
import { text } from "../utils/i18n";
import { usePaymentViewMutator, usePaymentViewState } from "./payment-view";
import { Checkbox, Field } from "../components/fields";
import { usePaymentsMutator, usePaymentsState } from "../contexts/payments";
import { post } from "../utils/rmi";
import { ConfirmationModal } from "../components/modals";
import { useModalsMutator } from "../contexts/page";
import { generateSchema, prop } from "../utils/schema";
import {Form, useFormMutator, useFormState} from '../components/form';
import {getIconNameForPaymentType, getNameForPaymentType} from "../utils/payments";
import {useCustomerState} from "../contexts/customer";


const iconHeaderStyling = {
    marginTop: '15px'
};
const cancelStyling = {
    fontWeight:'400',
    lineHeight:'0.95'
};
const buttonCentering = {
    margin: '20px auto'
};
const bottomBackStyling = {
    margin: '0'
};

const btnLink = "btn btn-link";

const EditDigitalWalletForm = ()=> {

    const { initial, fieldDisabledValue } = useFormState();
    const { viewOptions } = usePaymentViewState();
    const { setFieldDisabledValue } = useFormMutator();
    const isPaymentDefault = initial && initial.makeDefault;

    const setDigitalWalletDefaultValues = (e) => {
        setFieldDisabledValue(isPaymentDefault === e.target.checked);
    };

    return (
        <>
            {viewOptions.makeDefault &&
                <Field component={Checkbox} id="makeDefault" name="makeDefault"
                       labelKey={"form.paymentManagement.makeDefault"} classes="form-control"
                       labelClasses="shipping-label" onChange={setDigitalWalletDefaultValues}/>
            }
            <div className="text-center">
                <SubmitButton id={"paymentAddSubmit"} disabled={fieldDisabledValue} text={text("form.paymentManagement.savePayment")} classes={"btn btn-primary"} cssStyles={buttonCentering} />
            </div>
        </>
    );
};

export const EditDigitalWalletPanel = (props) => {
    const { bottomBackButton } = props;
    const { viewOptions } = usePaymentViewState();
    const { hasActiveLrp } = useCustomerState();
    const { showPaymentList } = usePaymentViewMutator();
    const { removePayment, editPayment } = usePaymentsMutator();
    let { editTarget:payment, isEditingCartPayment } = usePaymentsState();
    const { showGlobalModal, hideGlobalModal } = useModalsMutator();

    if (!payment) {
        return null;
    }

    const formSchema = {
        fields: {
            id: prop().required(),
            code: prop().required(),
            digitalWalletType: prop().required(),
            makeDefault: prop('boolean')
        }
    };

    const handleDelete = useCallback(() => {
        const routeToShopHome = () => {
          let redirectUrl = contextPath + "/shop";
          let isSubscriptionEnabled = $('#isSubscriptionEnabled').val() === 'true';
          if (isSubscriptionEnabled) {
            redirectUrl = contextPath + '/subscriptions';
          }
          window.location.href = redirectUrl;
        };

        const deleteConfirmed = () => {
            removePayment(payment.id).then(() => {
                showPaymentList();

            });
        };

        post("/my-account/checkForLRPTemplate/Payment/" + payment.id, null, (isLRPPayment) => {
            if (isLRPPayment) {
                const modalName = 'lrp-payment-check';
                showGlobalModal(modalName, <ConfirmationModal
                    type='warning'
                    text={text('form.paymentMethod.confirmLRP')}
                    rejectText={text('form.paymentMethod.returnToPayments')}
                    rejectClassNames='info'
                    acceptText={text('text.button.label.goToLRP')}
                    accept={routeToShopHome}
                    close={() => hideGlobalModal(modalName)}
                    />
                );
            } else {
                const modalName = 'confirm-payment-delete';
                showGlobalModal(modalName, <ConfirmationModal
                    type='warning'
                    text={text('form.paymentMethod.confirmDelete')}
                    rejectText={text('text.button.label.no')}
                    rejectClassNames='info'
                    acceptText={text('text.button.label.yes')}
                    accept={deleteConfirmed}
                    close={() => hideGlobalModal(modalName)}
                    />
                );
            }
        }, null, null);
    });

    const handleSubmit = useCallback(values => {
        const data = {
            ...values,
            digitalWalletType: payment.type,
            id:payment.id,
            code:payment.code
        };
        editPayment(data).then(result => {
            if (result) {
                showPaymentList();
            }
        });
    });

    const DeletePayment = () => { return ((!payment.defaultPayment || (payment.defaultPayment && !hasActiveLrp)) && !isEditingCartPayment()) ? <div className={btnLink} onClick={handleDelete} style={cancelStyling}>{text("form.paymentManagement.deletePayment")}</div> : null;};

    return (
        <>
        <div className="row">
            <div className={`col-xs-12${viewOptions.fullWidth ? '' : ' col-md-6'}`}>
                <div className='manage-credit-card panel panel-product panel-default doterra-payment-item'>
                    <div className='list-group-item'>
                        <div className='payment-header'>
                            <div className='payment-title'>
                                <Icon name={getIconNameForPaymentType(payment.type)} size='medium' cssStyles={iconHeaderStyling}/>
                                <h5>
                                    {getNameForPaymentType(payment.type)}
                                </h5>
                            </div>
                            {!bottomBackButton &&
                                <div className='payment-back'>
                                    <Button id={"hidePayment"} disabled={false} text={text("text.button.label.back")} classes={btnLink} ariaLabel={text("text.button.label.back.payment.method")} onClick={showPaymentList} cssStyles={cancelStyling}/>
                                </div>
                            }
                        </div>
                        <div>
                            {payment.displayedAcct}
                        </div>

                        <Form schema={formSchema} initial={generateSchema(formSchema.fields)} onSubmit={handleSubmit}>
                            <EditDigitalWalletForm payment={payment}/>
                        </Form>

                        <div className="text-center">
                            <DeletePayment/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {bottomBackButton &&
            <div className='text-center'>
                <Button id={"hidePayment"}
                        disabled={false}
                        text={'Select a different Payment Method'}
                        classes={"btn btn-link"}
                        ariaLabel='Back to payment method'
                        onClick={showPaymentList}
                        cssStyles={bottomBackStyling}/>
            </div>
        }
    </>
    );

};


